/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DiffRecords } from "./DiffRecords";
export const DiffRecordsResponse = core.serialization.object({
    data: DiffRecords,
});
